import { FrontendOrganizationInvite } from '@trucksmarter/shared';
import Endpoint from '../endpoints';
import { makeClientSideRequest } from './http-client';

export async function acceptInvite(secureToken: string) {
  return makeClientSideRequest<
    { secureToken: string },
    FrontendOrganizationInvite
  >(Endpoint.AcceptOrganizationInvite, { secureToken });
}

export async function declineInvite(secureToken: string) {
  return makeClientSideRequest<
    { secureToken: string },
    FrontendOrganizationInvite
  >(Endpoint.DeclineOrganizationInvite, { secureToken });
}
